import { Grid, Card, MenuItem, CircularProgress, Backdrop } from "@mui/material";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import configurations from "config";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { State } from 'country-state-city';
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import { handleErrors } from "common";

function PickupLocation() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const baseUrl = configurations.baseUrl;
    const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
    const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
    const [isLoading, setIsLoading] = useState(false);
    const states = State.getStatesOfCountry("IN");
    const { register, handleSubmit, formState: { errors }, setValue, setError, control } = useForm();

    const fetchData = async () => {
        setIsLoading(true)
        await axios.get(baseUrl + '/vendor/getPickupLocation', {
            headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey },
        }).then((response) => {
            setIsLoading(false);
            const requestStatus = response.status;
            if (requestStatus == 200) {
                const status = response.data.status;
                const message = response.data.message;
                if (status == 1) {
                    const responseData = response.data.data;
                    if (responseData) {
                        Object.entries(responseData).forEach(([key, value]) => {
                            setValue(key, value);
                        });
                    }
                }
                else {
                    toast.error(t(message));
                }
            }
            else {
                toast.error(t('unableToProccessRequest'));
            }
        }).catch(error => {
            setIsLoading(false);
            handleErrors(error, t, navigate);
        });
    };

    useEffect(() => {
        fetchData();
    }, []);

    const onSubmit = async (data) => {
        setIsLoading(true)
        axios.post(baseUrl + '/vendor/savePickupLocation', data, {
            headers: { Authorization: bearerToken }
        }).then((response) => {
            setIsLoading(false)
            if (response.status == 200) {
                const status = response.data.status;
                const message = response.data.message;
                if (status == 1) {
                    if (response.data.data.id)
                        setValue('id', response.data.data.id)
                    toast.success(t(message))
                }
                else {
                    if (message != '')
                        toast.error(t(message))
                    if (response && response.data && response.data.errors) {
                        const errorData = response.data.errors;
                        errorData.forEach((error) => {
                            setError(error.field, {
                                type: 'server',
                                message: t(error.errors[0])
                            });
                        });
                    }
                }
            }
            else {
                toast.error(t('unableToProccessRequest'));
            }
        }).catch(error => {
            setIsLoading(false)
            handleErrors(error, t, navigate);
        });
    }
    return (
        <DashboardLayout>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
            <DashboardNavbar pageTitle={t('pickupLocation')} />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)} pt={3} pb={3}>
                                <MDBox px={3}>
                                    <Grid container spacing={2} mt={0}>
                                        <Grid item xs={12} sm={4} md={4}>
                                            <MDTypography variant="body1" className="labelStyle">{t('phone')}
                                                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                            </MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={8} md={8}>
                                            <MDInput
                                                type="text"
                                                name="phone"
                                                placeholder={t('enterPhone')}
                                                InputProps={{
                                                    classes: { root: "inputBoxStyle" },
                                                }}
                                                {...register("phone", {
                                                    required: {
                                                        value: true,
                                                        message: t('mobileNumberRequired')
                                                    },
                                                    pattern: {
                                                        value: /^[0-9]{10}$/,
                                                        message: t('mobileNumberInvalidFormat')
                                                    }
                                                })}
                                                onChange={((e) => { e.stopPropagation() })}
                                                fullWidth
                                            />
                                            {errors.phone && (<span className="errorMsg floatRight">{errors.phone.message}</span>)}
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                            <MDTypography variant="body1" className="labelStyle"> {t('email')}
                                                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                            </MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={8} md={8}>
                                            <MDInput
                                                type="text"
                                                name="email"
                                                placeholder={t('enterEmail')}
                                                InputProps={{
                                                    classes: { root: "inputBoxStyle" },
                                                }}
                                                {...register("email", {
                                                    required: {
                                                        value: true,
                                                        message: t('emailRequired')
                                                    },
                                                    pattern: {
                                                        value: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/,
                                                        message: t('invalidEmail')
                                                    }
                                                })}
                                                onChange={((e) => { e.stopPropagation() })}
                                                fullWidth />
                                            {errors.email && (<span className="errorMsg floatRight">{errors.email.message}</span>)}
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                            <MDTypography variant="body1" className="labelStyle">{t('pickupLocatonAddress')}
                                                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                            </MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={8} md={8}>
                                            <MDInput
                                                type="text"
                                                name="address"
                                                placeholder={t('enterAddress')}
                                                multiline
                                                maxRows={8}
                                                InputProps={{
                                                    classes: { root: "textareaHeight" },
                                                }}
                                                {...register("address", {
                                                    required: {
                                                        value: true,
                                                        message: t('addressRequired')
                                                    },
                                                })}
                                                onChange={((e) => { e.stopPropagation() })}
                                                fullWidth />
                                            <MDTypography component="span" variant="body2" color="info">{t('addressNote')}</MDTypography>
                                            {errors.address && (<span className="errorMsg floatRight">{errors.address.message}</span>)}
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                            <MDTypography variant="body1" className="labelStyle">{t('country')}
                                                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                            </MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={8} md={8}>
                                            <MDInput
                                                type="text"
                                                name="country"
                                                {...register("country")}
                                                value="India"
                                                disabled={true}
                                                InputProps={{
                                                    classes: { root: "inputBoxStyle" },
                                                }}
                                                fullWidth />
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                            <MDTypography variant="body1" className="labelStyle">{t('state')}
                                                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                            </MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={8} md={8}>
                                            <Controller
                                                name="state"
                                                placeholder={t('enterState')}
                                                control={control}
                                                rules={{
                                                    required: {
                                                        value: true,
                                                        message: t('stateRequired')
                                                    },
                                                    validate: (value) => {
                                                        if (value === 0) {
                                                            return t('stateRequired');
                                                        }
                                                        return true;
                                                    },
                                                }}
                                                defaultValue={0}
                                                render={({ field }) => (
                                                    <MDInput
                                                        select
                                                        {...field}
                                                        fullWidth
                                                        InputProps={{
                                                            classes: { root: "select-input-styles dropdownPadding" },
                                                        }}
                                                    >
                                                        <MenuItem key={0} value={0} >{t('select')}</MenuItem>
                                                        {states.map((state) => (<MenuItem key={state.isoCode} value={state.isoCode}>{state.name}</MenuItem>))}
                                                    </MDInput>
                                                )}
                                            />
                                            {errors.state && (<span className="errorMsg floatRight">{errors.state.message}</span>)}
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                            <MDTypography variant="body1" className="labelStyle">{t('city')}
                                                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                            </MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={8} md={8}>
                                            <MDInput
                                                type="text"
                                                name="city"
                                                placeholder={t('enterCity')}
                                                InputProps={{
                                                    classes: { root: "inputBoxStyle" },
                                                }}
                                                {...register("city", {
                                                    required: {
                                                        value: true,
                                                        message: t('cityRequired')
                                                    },
                                                })}
                                                onChange={((e) => { e.stopPropagation() })}
                                                fullWidth />
                                            {errors.city && (<span className="errorMsg floatRight">{errors.city.message}</span>)}
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}>
                                            <MDTypography variant="body1" className="labelStyle">{t('pincode')}
                                                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                                            </MDTypography>
                                        </Grid>
                                        <Grid item xs={12} sm={8} md={8}>
                                            <MDInput
                                                type="text"
                                                name="pin"
                                                placeholder={t('enterPincodeHere')}
                                                InputProps={{
                                                    classes: { root: "inputBoxStyle" },
                                                }}
                                                {...register("pin", {
                                                    required: {
                                                        value: true,
                                                        message: t('pinRequired')
                                                    },
                                                    pattern: {
                                                        value: /^\d{6}$/,
                                                        message: t('invalidpin')
                                                    }
                                                })}
                                                onChange={((e) => { e.stopPropagation() })}
                                                fullWidth />
                                            {errors.pin && (<span className="errorMsg floatRight">{errors.pin.message}</span>)}
                                        </Grid>
                                        <Grid item xs={12} sm={4} md={4}></Grid>
                                        <Grid item xs={12} sm={8} md={8}>
                                            <MDButton type="submit" variant="gradient" color="info" disableRipple>{t('submit')}</MDButton>
                                        </Grid>
                                    </Grid>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            {/* <Footer /> */}
        </DashboardLayout >
    );
}

export default PickupLocation;
